<script setup lang="ts">
/**
 * HomeView — landing page rendered by the Story 301 shell. Subsequent
 * stories link to /configure, /chat, /tools, /health, /errors.
 */
import PageHeader from '../components/PageHeader.vue';
import Card from '../components/Card.vue';
import EmptyState from '../components/EmptyState.vue';
import AppAlert from '../components/AppAlert.vue';
</script>

<template>
  <div>
    <PageHeader
      title="Connect with Claude"
      subtitle="Test application — exercises the @gl-demo-ultimate-odupre/connect-with-claude library against the Anthropic API."
    />
    <AppAlert variant="info" title="Demo build">
      This UI shells out to the connect-with-claude library shipped in
      Epic 1+2. Stories 302-307 wire up configuration, chat, tools, health,
      and error UX.
    </AppAlert>
    <div class="cwc-home__grid">
      <Card title="Status">
        <p>Application shell bootstrapped. Pajamas tokens active.</p>
      </Card>
      <Card title="Available now">
        <ul>
          <li><a href="#/configure">Connection configuration</a> (Story 302)</li>
          <li><a href="#/chat">Chat interface</a> (Story 303 + 304)</li>
          <li><a href="#/tools">Tool use demo</a> (Story 305)</li>
          <li><a href="#/health">Health dashboard</a> (Story 306)</li>
        </ul>
      </Card>
      <Card title="Coming up">
        <ul>
          <li>Error states (Story 307)</li>
        </ul>
      </Card>
    </div>
    <EmptyState
      title="No connection configured yet"
      description="Visit the configuration page to set your API key and run a health check."
    />
  </div>
</template>

<style scoped>
.cwc-home__grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: var(--gl-spacing-5);
  margin: var(--gl-spacing-5) 0;
}
</style>
